<!-- TEMPLATE -->
<template>
  <div
    class="dean-input-field"
    @mouseover="ctrlCAllowed = true"
    @mouseleave="ctrlCAllowed = false"
  >
    <input
      v-if="passwordShow == false"
      :type="deanInputFieldType"
      :class="validationClass"
      :name="name"
      v-model="inputValue"
      @input="updateValue($event.target.value)"
      :tab-index="tabIndex"
      :disabled="disabled"
      :readonly="readonly"
      @focus="onfocus(label)"
      @blur="onblur(label)"
    />
    <input
      v-if="passwordShow == true"
      type="text"
      class="show-password-focus"
      :name="name"
      v-model="inputValue"
      @input="updateValue($event.target.value)"
      :tab-index="tabIndex"
      :disabled="disabled"
      :readonly="readonly"
      @focus="onfocus(label)"
      @blur="onblur(label)"
    />
    <div
      v-if="deanInputFieldType == `password`"
      class="show-password">
      <dean-icon
        class="icon"
        v-if="deanInputFieldType == 'password' && passwordShow == false"
        :glyph="detailsIcon"
        :height="15"
        :width="15"
        @click.native="passwordShowClick()"
      >
      </dean-icon>
      <dean-icon
        class="icon"
        v-if="deanInputFieldType == 'password' && passwordShow == true"
        :glyph="detailsCloseIcon"
        :height="15"
        :width="15"
        @click.native="passwordShowClick()"
      >
      </dean-icon>
      <transition name="fade" mode="out-in" appear>
        <dean-icon
          class="icon"
          v-if="deanInputFieldType == 'password' && inputValue.length > 0 && this.copied == false"
          :glyph="copyIcon"
          :height="15"
          :width="15"
          @click.native="copy()"
        >
        </dean-icon>
      </transition>
      <transition name="fade" mode="out-in" appear>
        <dean-icon
          class="copied"
          v-if="copied"
          :glyph="copyIcon"
          :height="30"
          :width="30"
        >
        </dean-icon>
      </transition>
    </div>
    <div v-if="disabled" class="disabled">
      <dean-icon class="icon" :glyph="forbiddenIcon" :height="15" :width="15">
      </dean-icon>
    </div>
    <span :class="labelClass">
      <span :class="labelTextClass">
        <slot></slot>
      </span>
      <span v-if="requiredField" class="required-field"> * </span>
    </span>
    <span :class="labelClass" v-if="type == 'time'">00:00</span>
  </div>
</template>

<!-- SCRIPT -->
<script lang="ts">
// VUE
import Vue from "vue";
import { Component, Prop, Emit, Watch } from "vue-property-decorator";

import { detailsIcon, detailsCloseIcon, forbiddenIcon, copyIcon } from "../";

// COMPONENTS
import deanIcon from "./deanIcon.vue";

@Component({
  components: {
    deanIcon,
  },
})
export default class deanInputField extends Vue {
  // PROPS
  @Prop({ default: "" }) value!: string;
  @Prop({ default: true }) text!: boolean;
  @Prop({ default: false }) disabled!: boolean;
  @Prop({ default: false }) readonly!: boolean;
  @Prop({ default: false }) password!: boolean;
  @Prop({ default: false }) tel!: boolean;
  @Prop({ default: false }) number!: boolean;
  @Prop({ default: false }) warning!: boolean;
  @Prop({ default: false }) requiredField!: boolean;
  @Prop({ default: "" }) type!: string;
  @Prop({ default: "" }) validation!: string;
  @Prop({ default: "" }) label!: string;
  @Prop({ default: "" }) name!: string;
  @Prop({ default: "" }) id!: string;
  @Prop() tabIndex!: number;

  // DATA
  detailsIcon: object = detailsIcon;
  detailsCloseIcon: object = detailsCloseIcon;
  forbiddenIcon: object = forbiddenIcon;
  copyIcon: object = copyIcon;
  passwordShow: boolean = false;
  hideLabel: boolean = false;
  copied: boolean = false;
  inputValue: string = this.value;
  slotText!: string;

  keyPressCtrlC = {
    ctrl: false,
    c: false,
  };

  ctrlCAllowed = false;

  @Watch("value")
  valueChange() {
    this.inputValue = this.value;
  }

  @Watch("inputValue")
  inputValueChange(value: string) {
    this.inputHasValue(value);
    let inputData = {
      id: this.id,
      label: this.label,
      value: value,
    };

    if (this.label == "") {
      inputData.label = this.slotText;
    }

    this.$emit("inputData", inputData);
  }

  // EMIT
  @Emit("input")
  updateValue(value: string) {
    if (value != "" && value != null && value != undefined) {
      this.hideLabel = true;
    } else {
      this.hideLabel = false;
    }
  }

  // COMPUTED
  get selection() {
    return window.getSelection();
  }

  get deanInputFieldType() {
    let value = "";
    if (this.text) value = `text`;
    if (this.password) value = `password`;
    if (this.number) value = `number`;
    if (this.tel) value = `tel`;
    if (this.type) {
      value = `${this.type}`;
    }
    return value;
  }

  get validationClass() {
    let value = "";
    if (this.warning) value = `warning`;
    if (this.validation) {
      value = `${this.validation}`;
    }
    return value;
  }

  get labelClass() {
    let value = "label";
    if (this.hideLabel) value += ` shrink-label`;
    return value;
  }

  get labelTextClass() {
    let value = "label-text";
    if (this.type == "time") value += ` shrink-label`;
    return value;
  }

  // METHODS
  inputHasValue(value: string) {
    if (value != "" && value != null && value != undefined) {
      this.hideLabel = true;
    } else {
      this.hideLabel = false;
    }
  }

  passwordShowClick() {
    console.log(this.passwordShow);
    this.passwordShow = !this.passwordShow;
    console.log(this.passwordShow);
  }

  onfocus(label: string) {
    this.$emit("focus", true);
  }

  onblur(label: string) {
    this.$emit("focus", false);
  }

  keyPressListener(event) {
    if (this.ctrlCAllowed == true) {
      if (event.keyCode == 224 || event.keyCode == 67) {
        if (event.keyCode == 224) {
          this.keyPressCtrlC.ctrl = true;
        }
        if (event.keyCode == 67) {
          this.keyPressCtrlC.c = true;
        }
        console.log(this.keyPressCtrlC);
      } else {
        this.keyPressCtrlC = {
          ctrl: false,
          c: false,
        };
      }

      if (this.keyPressCtrlC.ctrl == true && this.keyPressCtrlC.c == true) {
        console.log(this.selection);
        this.copy();
        this.keyPressCtrlC = {
          ctrl: false,
          c: false,
        };
      }
    }
  }

  copy() {
    this.$copyText(this.inputValue).then(
      (response) => {
        this.copied = true;
        const self = this;
        setTimeout(() => {
          self.copied = false;
        }, 0.1);
        this.$emit("copy", true);
      },
      (error) => {
        this.$emit("copy", false);
      }
    );
  }

  mounted() {
    if (this.$slots.default != undefined) {
      this.slotText = String(this.$slots.default[0].text).replace(/\s+/g, "");
    }
  }

  created() {
    this.inputHasValue(this.inputValue);
    window.addEventListener("keydown", this.keyPressListener);
  }

  destroyed() {
    window.removeEventListener("keydown", this.keyPressListener);
  }
}
</script>

<!-- STYLE -->
<style lang="scss" scoped>
// IMPORT
@import "../scss/vars";

// DEAN INPUT FIELD
.dean-input-field {
  @include display-flex();
  justify-content: flex-end;
  align-content: center;
  position: relative;
  width: 100%;
  padding: 5px 10px 5px 10px;

  input {
    padding: 18px 10px 2px 10px;
    height: 40px;
    background: none;
    background: linear-gradient(
      to left,
      white 50%,
      var(--color-light-shade-3, $color-light-shade-3) 50%
    );
    background-size: 200% 100%;
    background-position: right bottom;
    border: 1px solid var(--color-light-shade-1, $color-light-shade-1);
    width: 100%;
    //@include calc(width, "100% - 20px")
    @include border-radius(10px);
    @include transition(all ease 0.8s);

    &:focus {
      outline: none;
      background-position: left bottom;
      box-shadow: 0px 0px 10px 2px var(--color-secondary, $color-secondary);
    }

    &:-webkit-autofill {
      border: 1px solid var(--color-autofill, $color-autofill);
    }

    &:-webkit-autofill ~ .label {
      top: -1px;
      font-size: 7.5pt;
      color: var(--color-autofill-dark, $color-autofill-dark);
    }

    &:-webkit-autofill ~ .show-password {
      fill: var(--color-autofill-dark, $color-autofill-dark);
    }

    &:-webkit-autofill ~ .show-password-active {
      fill: var(--color-secondary $color-secondary);
    }

    &:focus ~ .label {
      top: -1px;
      font-size: 7.5pt;
      color: var(--color-secondary, $color-secondary);
    }

    &[value=""] ~ .label {
      opacity: 1;
    }
    &:disabled,
    &:read-only {
      color: var(--color-dark, $color-dark);
      border: 1px solid var(--color-light-shade-3, $color-light-shade-3);
      background: var(--color-light-shade-3, $color-light-shade-3);
      font-family: "Avenir-Medium", Tahoma, Helvetica, sans-serif;
    }
  }

  .label {
    position: absolute;
    left: 10px;
    top: 5px;
    height: 30px;
    padding: 10px;
    font-family: "Avenir-Medium", Tahoma, Helvetica, sans-serif;
    user-select: none;
    color: var(--color-dark-shade-3, $color-dark-shade-3);
    pointer-events: none;
    overflow: hidden;
    @include opacity(1, 0.8s);
    @include transition(all ease 0.4s);
    @include text-select-none();
    .required-field {
      color: var(--color-info-danger, $color-info-danger);
    }
  }
  .shrink-label {
    top: -1px;
    font-size: 7.5pt;
    opacity: 1;
  }

  .warning {
    box-shadow: 0px 0px 10px 2px var(--color-info-warning, $color-info-warning);

    &:focus {
      box-shadow: 0px 0px 10px 2px var(--color-secondary, $color-secondary);
    }
  }

  .disabled {
    display: inline-flex;
    position: absolute;
    justify-content: flex-end;
    align-content: center;
    padding: 12.5px;
    height: 40px;
    width: 40px;
    cursor: not-allowed;
    fill: var(--color-dark-shade-3, $color-dark-shade-3);
    @include border-radius(100px);
    .icon {
      background: white-alpha;
    }
  }

  .icon {
    margin-left: 5px;
    cursor: pointer;
    &:hover {
      fill: var(--color-link, $color-link);
    }
  }

  .copied {
    position: absolute;
    display: inline-flex;

    fill: var(--color-link, $color-link);
  }

  .show-password {
    display: inline-flex;
    position: absolute;
    justify-content: flex-end;
    align-content: center;
    padding: 12.5px;
    cursor: pointer;
    fill: var(--color-dark-shade-4, $color-dark-shade-4);
    font-family: "Courier New", monospace;
    font-size: 12pt;
  }

  .show-password-focus {
    box-shadow: 0px 0px 10px 2px
      var(--color-info-standard-bg, $color-info-standard-bg);
    font-family: "Courier New", monospace;
    font-size: 12pt;
  }
}
</style>
